const parseSpecialOfferForEdit = (changedSpecialOffer) => {
  if (!changedSpecialOffer) return undefined;
  return {
    id: changedSpecialOffer.get('id'),
    title: changedSpecialOffer.get('title'),
    subtitle: changedSpecialOffer.get('subtitle'),
    productId: changedSpecialOffer.get('productId'),
    logo: changedSpecialOffer.get('picture'),
  }
};

export default parseSpecialOfferForEdit;




// WEBPACK FOOTER //
// ./src/helpers/parseSpecialOfferForEdit.js